/**
 * Automatically resizes the element to the current window height
 */
angular.module('qkr').directive('resize', ($window) => function(scope, element) {
        const w = angular.element($window);
        scope.getWindowDimensions = function() {
            return w.height();
        };
        scope.$watch(scope.getWindowDimensions, (newValue, oldValue) => {
            scope.windowHeight = newValue;
            element.css('height', newValue + 'px');
        }, true);

        w.bind('resize', () => {
            scope.$apply();
        });
    });



// WEBPACK FOOTER //
// ./src/directives/resize.js